<template>
    <button
        class="o-w-item-tile w-item-tile"
        type="button"
        role="button"
        :aria-label="`${ariaLabel}${t(item, 'name')}`"
        @click="onClick"
    >
        <svg-icon
            original
            name="icons/marker"
            class="w-item-tile__icon"
        />
        <div class="w-item-tile__wrapper">
            <span class="w-item-tile__title">
                {{ t(item, 'name') }}
            </span>
            <AItemInfoContrast
                :target-zone="t(getCategoryById(item.lists.target_zone), 'name')"
                :floor="t(denormalisedObject.floor, 'name')"
            />
        </div>
    </button>
</template>

<script>
import { mapGetters } from 'vuex';

import AItemInfoContrast from '../../atoms/a-item-info-contrast/a-item-info-contrast';

export default {
    name: 'OWItemTile',
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        ariaLabel: {
            type: String,
            default: 'Title - '
        }
    },
    components: {
        AItemInfoContrast
    },
    computed: {
        ...mapGetters([
            't',
            'getCategoryById',
            'getDenormalisedObjectById'
        ]),
        denormalisedObject() {
            return this.getDenormalisedObjectById(this.item.id);
        }
    },
    methods: {
        onClick() {
            this.$emit('onClick', this.item);
        }
    }
}
</script>

<style lang="scss">
@import "o-w-item-tile"; 
</style>